const en_booking = {
  "booking.hero.badge": "Book Appointment",
  "booking.hero.heading": "Book Your Assessment Session",
  "booking.hero.desc": "4 simple steps to book a deep assessment session with one of our specialized consultants",

  "booking.progress.service": "Service",
  "booking.progress.doctor": "Doctor",
  "booking.progress.datetime": "Date & Time",
  "booking.progress.info": "Your Info",
  "booking.progress.step_indicator": "Step {{current}} of {{total}}",

  "booking.step1.heading": "Choose a Service",
  "booking.step1.desc": "Start by selecting the service you need",
  "booking.step1.filter_all": "All",
  "booking.step1.selected": "Selected Service",
  "booking.step1.continue": "Continue — Choose Doctor",
  "booking.step1.from": "From",
  "booking.step1.clear_all": "Clear All",
  "booking.confirm.service_price": "Service Price",

  "booking.step2.heading": "Choose a Doctor",
  "booking.step2.desc": "Select the consultant best suited for your case",
  "booking.step2.search": "Search by name or specialty...",
  "booking.step2.visit_type": "Visit Type",
  "booking.step2.first_visit": "First Visit",
  "booking.step2.followup": "Follow-up",
  "booking.step2.consultation": "Consultation",
  "booking.step2.first_visit_desc": "For new patients",
  "booking.step2.followup_desc": "For existing patients",
  "booking.step2.consultation_desc": "Specialist medical opinion",
  "booking.step2.selected_services": "Selected Services:",
  "booking.step2.change": "Change",
  "booking.step2.choose_docs": "Choose Doctors for Selected Services",
  "booking.step2.choose_docs_desc": "Please select the preferred doctor for each medical service",
  "booking.step2.choose_visit_type": "Visit Type",
  "booking.step2.choose_doc_for_svc": "Choose the treating doctor for this service:",
  "booking.step2.specialist_first": "Specialists in Your Service",
  "booking.step2.other_doctors": "Other Consultants",
  "booking.step2.continue": "Continue — Choose Date & Time",

  "booking.step3.heading": "Choose Date & Time",
  "booking.step3.desc": "Select a convenient date and time",
  "booking.step3.morning": "Morning",
  "booking.step3.afternoon": "Afternoon",
  "booking.step3.evening": "Evening",
  "booking.step3.booked": "Booked",
  "booking.step3.selected_slot": "Selected Slot",
  "booking.step3.continue": "Continue — Your Info",
  "booking.step3.selected_doctors": "Selected Treating Doctors:",
  "booking.step3.this_week": "This week",
  "booking.step3.next_week": "Next week",
  "booking.step3.week_num": "Week {{num}}",
  "booking.step3.available_time": "Available Time",
  "booking.step3.selected": "Selected",
  "booking.step3.select_date_prompt": "Choose a date to view available appointments",
  "booking.step3.slot_selected_badge": "Appointment selected",

  "booking.step4.heading": "Your Personal Information",
  "booking.step4.summary": "Booking Summary",
  "booking.step4.name": "Full Name",
  "booking.step4.phone": "Phone Number",
  "booking.step4.email": "Email Address",
  "booking.step4.age": "Age",
  "booking.step4.gender": "Gender",
  "booking.step4.male": "Male",
  "booking.step4.female": "Female",
  "booking.step4.notes": "Additional Notes",
  "booking.step4.notes_placeholder": "Any additional information you'd like to share with the doctor...",
  "booking.step4.confirm": "Confirm Booking",
  "booking.step4.terms": "By continuing, I agree to the Privacy Policy and Terms of Use",
  "booking.step4.subheading": "One last step to complete your booking",
  "booking.step4.undefined": "Not specified",
  "booking.step4.edit_slot": "Edit Appointment",
  "booking.step4.name_placeholder": "Enter your full name",
  "booking.step4.age_placeholder": "In years",
  "booking.step4.select_placeholder": "Choose...",
  "booking.step4.optional": "(Optional)",
  "booking.step4.max_chars": "Max 500 characters",
  "booking.step4.agree_prefix": "I agree to the ",
  "booking.step4.privacy_policy": "Privacy Policy",
  "booking.step4.agree_and": " and ",
  "booking.step4.terms_of_use": "Terms of Use",
  "booking.step4.submit_error": "An error occurred during submission. Please try again.",
  "booking.step4.confirming": "Confirming Booking...",

  "booking.confirmation.heading": "Your Booking is Confirmed!",
  "booking.confirmation.desc": "Our team will contact you within an hour to confirm the details",
  "booking.confirmation.ref": "Booking Reference",
  "booking.confirmation.home": "Back to Home",
  "booking.confirmation.another": "Book Another Appointment",

  "booking.info.confirm_title": "Instant Confirmation",
  "booking.info.confirm_desc": "Our team will contact you to confirm the appointment",
  "booking.info.secure_title": "Secure Data",
  "booking.info.secure_desc": "Your information is fully encrypted and protected",
  "booking.info.cancel_title": "Free Cancellation",
  "booking.info.cancel_desc": "You can cancel up to 24 hours in advance for free",

  "booking.confirm.calendar_event": "Medical appointment at The Medical Avenue",
  "booking.confirm.doctors": "Doctors",
  "booking.confirm.visit_type": "Visit Type",
  "booking.confirm.package": "Package",
  "booking.confirm.support_phone": "For inquiries: 011 234 5678",
  "booking.confirm.hello": "Hello {{name}}, your booking request has been successfully received",
  "booking.confirm.details_title": "Appointment Details",
  "booking.confirm.location_val": "King Fahd Road, Al Olaya, Riyadh",
  "booking.confirm.date": "Date",
  "booking.confirm.time": "Time",
  "booking.confirm.location": "Location",
  "booking.confirm.main_clinic": "Main Clinic",
  "booking.confirm.requested_services": "Requested Services:",
  "booking.confirm.selected_doctors": "Selected Treating Doctors:",
  "booking.confirm.consultation_fees": "Consultation Fee",
  "booking.confirm.total_fees": "Total Doctors Consultation Fees:",
  "booking.confirm.selected_package": "Selected Package",
  "booking.confirm.saved": "You saved",
  "booking.confirm.expected_duration": "Expected duration of examination:",
  "booking.confirm.prep_instructions": "Preparation Instructions for Examination",
  "booking.confirm.whats_next": "What happens next?",
  "booking.confirm.timeline.1.title": "Phone Confirmation",
  "booking.confirm.timeline.1.desc": "Our team will contact you within a few hours to confirm the appointment",
  "booking.confirm.timeline.2.title": "Reminder Message",
  "booking.confirm.timeline.2.desc": "You will receive a reminder message 24 hours before your appointment",
  "booking.confirm.timeline.3.title": "Arriving at Clinic",
  "booking.confirm.timeline.3.desc": "Arrive 15 minutes before your appointment with your ID",
  "booking.confirm.timeline.4.title": "Receive Report",
  "booking.confirm.timeline.4.desc": "You will receive your medical report electronically on the same day",
  "booking.confirm.location_title": "Clinic Location",
  "booking.confirm.clinic_name": "The Medical Avenue — Precision Medicine Platform",
  "booking.confirm.clinic_address": "King Fahd Road, Al Olaya, Riyadh 12345",
  "booking.confirm.clinic_hours": "Working hours: Saturday - Thursday, 8 AM - 10 PM",
  "booking.confirm.directions": "Directions",
  "booking.confirm.contact_us": "Contact Us",
  "booking.confirm.patient_info": "Patient Information",
  "booking.confirm.name_label": "Name",
  "booking.confirm.phone_label": "Phone Number",
  "booking.confirm.email_label": "Email Address",
  "booking.confirm.cancel_note": "You can cancel or modify your appointment for free 24 hours before the scheduled time. To cancel, contact us via WhatsApp or call {{phone}} stating the booking reference {{ref}}.",
  "booking.confirm.confirmed_badge": "Confirmed",
  "booking.confirm.copied": "Copied!",
  "booking.confirm.copy_num": "Copy Number",
  "booking.confirm.shared": "Shared!",
  "booking.confirm.share": "Share",
  "booking.confirm.share_title": "Booking Confirmation — The Medical Avenue",
  "booking.confirm.share_template": "My booking has been confirmed at The Medical Avenue\nBooking Ref: {{ref}}\nName: {{name}}",
  "booking.confirm.ref_card_note": "Our team will contact you at {{phone}} to confirm the appointment within a few hours. Please keep your booking reference for review.",
  "booking.banner.preselected": "Preselected Package",
  "booking.banner.view_details": "View Details",
  "booking.banner.hide": "Hide",
  "booking.banner.more_features": "+{{count}} more features",
  "booking.banner.auto_added_note": "This package will be automatically added to your booking. You can change it at any time.",
  "common.sar": "SAR",
};

export default en_booking;
